import type { Role } from './role';

/**
 * Who is asked before an action is applied. The request of 5 October 2026
 * (third), section 2: every action by the accountant, the admin and the
 * receptionist shows a confirmation first.
 *
 * There is no admin role: `admin` is a permission only management holds, so the
 * admin is the management role. The rule reads the role and never a permission,
 * because a department supervisor is a technician who also holds `finalcheck`
 * and `assign`, and a technician is asked nothing new.
 */
export const CONFIRMING_ROLES = ['management', 'reception', 'accountant'] as const satisfies readonly Role[];

/**
 * Whether this role confirms an action before it is applied.
 *
 * A role not known yet, the session still on its way, is asked: a question too
 * many costs one tap, and an action applied unasked cannot be taken back.
 */
export function confirmsActions(role: Role | undefined): boolean {
  return role === undefined || (CONFIRMING_ROLES as readonly Role[]).includes(role);
}
